import { Apple, Smartphone } from 'lucide-react';
import { AiOutlineApple } from "react-icons/ai";

const FinalCTA = () => {
  return (
    <section className="relative py-40 px-6 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-black/90 via-black to-black/90" />

      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-radial from-blue-600/30 via-transparent to-transparent" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#1abc9c] rounded-full filter blur-[150px] animate-pulse" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto text-center">
        <div className="mb-12">
          <h2 className="text-6xl md:text-7xl font-bold text-white mb-8 text-glow">
            Start Billing
            <br />
            <span className="gradient-text">Beautifully.</span>
          </h2>
          <p className="text-2xl text-white/70 max-w-2xl mx-auto">
            Join thousands of professionals who've elevated their invoicing experience.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-16">
          {/* <button className="group px-10 py-5 bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-500 hover:to-cyan-500 text-white rounded-2xl font-semibold text-lg transition-all duration-300 transform hover:scale-105 shadow-[0_0_60px_rgba(0,122,255,0.5)] hover:shadow-[0_0_80px_rgba(0,122,255,0.7)] flex items-center gap-3">
            <Apple className="w-6 h-6" />
            App Store
          </button> */}
          
          <button className="group px-14 py-5 glass-effect text-white rounded-2xl font-semibold text-lg hover:bg-white/15 transition-all duration-300 transform hover:scale-105 border-2 border-white/20 hover:border-white/30 flex items-center gap-3">
            {/* <Smartphone className="w-6 h-6" /> */}
            {/* Google Play */}
            <AiOutlineApple size={26} style={{marginBottom:2}} />
            App Store
          </button>
        </div>

        <div className="glass-card rounded-3xl p-6 sm:p-12 max-w-3xl mx-auto">
          <div className="grid grid-cols-3 gap-8">
            <div>
              <div className="text-2xl md:text-4xl font-bold text-white mb-2">100+</div>
              <div className="text-white/60 text-sm sm:text-base">Active Users</div>
            </div>
            <div>
              <div className="text-2xl md:text-4xl font-bold text-white mb-2">4.9</div>
              <div className="text-white/60 text-sm sm:text-base">App Store Rating</div>
            </div>
            <div>
              <div className="text-2xl md:text-4xl font-bold text-white mb-2">1k+</div>
              <div className="text-white/60 text-sm sm:text-base">Invoices Sent</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FinalCTA